import { useQuery } from "@tanstack/react-query";
import { soatoService } from "../services/soato.service";
import type { ListSoatosParams } from "../types";

// ─── Query Keys ─────────────────────────────────────────────────────
export const soatoKeys = {
	all: ["soato"] as const,
	lists: () => [...soatoKeys.all, "list"] as const,
	list: (params?: ListSoatosParams) => [...soatoKeys.lists(), params] as const,
};

// ─── useSoatos ──────────────────────────────────────────────────────
export function useSoatos(params?: ListSoatosParams) {
	return useQuery({
		queryKey: soatoKeys.list(params),
		queryFn: () => soatoService.list(params),
	});
}
